// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__ezLWd","link":"Footer_link__28WpU","copyright":"Footer_copyright__1klEb"};